export type EnvType = "localhost" | "Testing" | "Production";

export type EnvConfig = {
	env: EnvType;
	apiRoute: string;
	clientId: string;
	domain: string;
};

/*
    This is a loose strategy to deal with env variables so we don't have to deal with .env files.
    This is not a good practice for a production application, but it's good enough for the demo purpose.
*/
export function useEnvConfig(): EnvConfig {
	const env = getEnv();

	switch (env) {
		case "localhost":
			return {
				// uncomment the next line and comment the following line to use the test API
				// apiRoute: "https://api.test.beca.digital/api/b2c-t01/data/v1",
				env,
				apiRoute: "https://localhost:7186",

				// (Same as Testing)
				clientId: "1940ce31-83d6-42cb-aed0-18aa141c801f", // Playground SPA
				domain: "identity.test.beca.digital",
			};
		case "Testing":
			return {
				env,
				apiRoute: "https://api.test.beca.digital/b2c-t01/data/v1",
				clientId: "1940ce31-83d6-42cb-aed0-18aa141c801f", // Playground SPA
				domain: "identity.test.beca.digital",
			};
		case "Production":
			return {
				env,
				apiRoute: "https://api.beca.digital/b2c/data/v1",
				clientId: "36754ed8-7308-42b4-b0fd-50e2a417f1c3", // Playground SPA
				domain: "identity.beca.digital",
			};
	}

	function getEnv(): EnvType {
		const origin = window.location.origin;

		if (origin.startsWith("http://localhost")) return "localhost";

		if (origin.startsWith("https://playground.identity.test.beca.digital")) return "Testing";

		if (origin.startsWith("https://playground.identity.beca.digital")) return "Production";
	}
}
